import type { PlannerAnswer } from '@platform/schema/chat';

/**
 * What one exchange with the planner cost — GEN-52.
 *
 * Four decimal places, and tokens always but dollars only sometimes. `chat.test.ts` names
 * the reason for each.
 *
 * The three fields rather than the whole answer, so the SDK's own shape satisfies it —
 * GEN-66 added a proposal the generated type renders more loosely than the schema does,
 * and a cost line has no business being narrowed by it.
 */
type Spent = Pick<PlannerAnswer, 'costUsd' | 'inputTokens' | 'outputTokens'>;

export function exchangeCost(answer: Spent): string {
  const spent = `${answer.inputTokens.toLocaleString()} tokens in, ${answer.outputTokens.toLocaleString()} out`;

  if (answer.costUsd <= 0) return spent;

  return `Estimated $${answer.costUsd.toFixed(4)} · ${spent}`;
}
